import { ecorEnv } from '@/../environments/environment';
import { PortalUser } from '@/common/components/ecorr-store/portal-user/portal-user';
import { PortalUserState } from '@/common/components/ecorr-store/portal-user/portal-user.state';
import { ParadataEventEnum, ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { Component, HostListener, Inject, OnDestroy, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators, ValidatorFn, AbstractControl, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { SurveySelectionDialogData } from '../../dialogs-data/survey-selection-dialog-data';
import { CalendarDialogComponent } from '../calendar-dialog/calendar-dialog.component';
import { CalendarDialogHttpService } from '../../services/calendar-dialog-http.service';
import { ExportSurveyDialogService } from '../../services/export-survey-dialog.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';

@Component({
    selector: 'app-survey-selection-dialog',
    templateUrl: './survey-selection-dialog.component.html',
    styleUrls: ['./survey-selection-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        NgxMaskModule
    ],
    providers: [
        ParadataEventService,
        CalendarDialogHttpService,
        ExportSurveyDialogService
    ]
})
export class SurveySelectionDialogComponent extends CalendarDialogComponent implements OnInit, OnDestroy {
    protected destroyRef = inject(DestroyRef);
    private userStore = inject(Store<PortalUserState>);
    private surveyParadataEventService = inject(ParadataEventService);
    private surveyExportSurveyDialogService = inject(ExportSurveyDialogService);
    private matDialogRef = inject(MatDialogRef<SurveySelectionDialogComponent>);
    private surveyCalendarDialogHttpService = inject(CalendarDialogHttpService);
    public surveySelectionDialogData!: SurveySelectionDialogData;;

    // Signals for reactive state
    private surveys = signal<string[]>([]);
    private selectedSurveyTypes = signal<string[]>([]);

    // Computed properties
    currentSurveys = computed(() => this.surveys());
    currentSelectedSurveyTypes = computed(() => this.selectedSurveyTypes());

    surveyForm: FormGroup = new FormGroup({});

    constructor() { 
        super();
        // Add null check for surveySelectionDialogData
        if (this.surveySelectionDialogData && this.surveySelectionDialogData.surveys) {
            this.surveys.set(this.surveySelectionDialogData.surveys);
        } else {
            console.error('SurveySelectionDialogData or surveys is undefined');
            this.surveys.set([]);
        }
    }

    ngOnInit() {
        if (this.surveySelectionDialogData?.surveys) {
        this.surveys.set(this.surveySelectionDialogData.surveys);
    }
        this.buildCheckboxes();
    }

    submit() {
        if ( this.surveyForm.valid ) {
            this.convertAnswers();
            this.exportSurvey();
            // this.close(true);
        }
    }

    exportSurvey() {
        this.generateCalendar(this.currentSelectedSurveyTypes(), null);
    }

    convertAnswers() {
        const newSelectedTypes: string[] = [];
        for (const [key, value] of Object.entries(this.surveyForm.value)) {
            if (value) { //if checked, add to list
                newSelectedTypes.push(key);
            }
        }
        this.selectedSurveyTypes.set(newSelectedTypes);
    }

    buildCheckboxes() {
        for (let survey of this.currentSurveys()) {
            let formControl: FormControl = new FormControl();
            this.surveyForm.setControl(survey, formControl);
        }
        this.surveyForm.setValidators(this.validateCheckboxes());
    }

    validateCheckboxes(): any {
      return (control: AbstractControl): { [key: string]: any } | null => {
          const minRequired = 1;
          var valid = true;
          var checked = 0;

          Object.keys(this.surveyForm.controls).forEach(key => {
              const control = this.surveyForm.controls[key];

              if (control.value) {
                  checked++;
              }
          });

          if (checked < minRequired) {
              valid = false;
          }
          return valid ? null : {allUnchecked: !valid, required: true};
      } 
    }

    clearForm() {
        this.buildCheckboxes();
    }

    cancel() {
        this.close('cancel');
    }

    ngOnDestroy() {
        this.surveyParadataEventService.flushParadataevents();
    }
}
